<div class="glow-pulse">
  <div #container class="particle-effect-container relative w-full h-full pointer-events-none"></div>

  <ng-container *ngIf="isActive">
    <div #glowRing class="glow-ring" [ngStyle]="glowRingStyle"></div>
  </ng-container>
</div>
